import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-contacts-icon',
    templateUrl: './contacts-icon.component.html',
    styleUrls: ['./contacts-icon.component.scss']
})
export class ContactsIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 20;
    }
}
